import axios from 'axios';
import {Message,MessageBox} from 'element-ui';
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie';
import errorCode from '@/utils/errorCode'
import store from "../store";

window.Global= {
  env: process.env.VUE_APP_BASE_API
};
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  // timeout: 8000,                  // 请求超时时间
  withCredentials: true
});

// request拦截器
service.interceptors.request.use(config => {
  config.headers.token = Cookies.get('token');
  config.headers['Content-Type'] = 'application/json;charset=utf-8;';
  return config;
}, error => {
  console.log(error); // for debug
  Promise.reject(error);
})


// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.resultCode || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.resultDesc || errorCode['default']

    if (code == 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('LogOut').then(() => {
          location.href = '/index';
        })
      })
    } else if (code == 500) {
      Message.error({message: msg})
      return Promise.reject(new Error(msg))
    }else if (code == 10010001) {
        Message.error({message: "登录状态已过期，请重新登录"});
        store.dispatch('LogOut').then(() => {
          location.href = '/index';
        })
    }  else if (code != 200) {
      Message.error({message: msg})

      return Promise.reject('error')
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)


export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js